import React, { createContext, useState } from "react";
import { ThemeProvider as StyledComponentProvider } from "styled-components";
import HFCLLightTheme from "../../token/theme/HFCLLightTheme";
import getTheme from "../../utils/getTheme";
import PropTypes from "prop-types";

export const ThemeContext = createContext({
  theme: HFCLLightTheme,
  platform: "desktop",
  setTheme : ()=>{}
});

const ThemeProvider = ({
  children,
  theme: defaultThemeType = "LIGHT",
  platform = "desktop",
}) => {
  const [themeType, setThemeType] = useState(defaultThemeType);
  const theme = getTheme(themeType);
  const changeTheme = (newThemeType) =>{
	setThemeType(newThemeType);
  }

  return (
    <ThemeContext.Provider value={{ theme, platform , setTheme:changeTheme}}>
      <StyledComponentProvider theme={theme}>
        <>{children}</>
      </StyledComponentProvider>
    </ThemeContext.Provider>
  );
};

ThemeProvider.defaultProps = {
  children: null,
};
ThemeProvider.propTypes = {
  children: PropTypes.node, // Validate children as a React node
  theme: PropTypes.string, // Validate theme as a string
  platform: PropTypes.string, // Validate platform as a string
};

export default ThemeProvider;
